import { useCallback, useEffect, useState } from 'react';

// The period pills persist within the Reports section ("filters persist within a section", Leo): one choice for the past pills and one for the forward pills, kept in
// memory in this module while the person moves between the reports. Never stored in the browser, never in a URL. A reload starts again at the default.

// The boards open on the whole year (monthly bars) and the forecast on six months.
const DEFAULTS = { past: { kind: 'this_year' }, forward: { kind: 'next_6_months' } };
let current = DEFAULTS;
const listeners = new Set();

export const resetReportPeriods = () => { current = DEFAULTS; listeners.forEach((l) => l()); };

// [period, setPeriod] for 'past' or 'forward'
export function useReportPeriod(which) {
  const [, force] = useState(0);
  useEffect(() => {
    const on = () => force((n) => n + 1);
    listeners.add(on);
    return () => { listeners.delete(on); };
  }, []);
  const set = useCallback((value) => { current = { ...current, [which]: value }; listeners.forEach((l) => l()); }, [which]);
  return [current[which], set];
}
